export default function MySQL_LPAD() {
  return (
    <div>
      <h2>MySQL_LPAD</h2>    </div>
  );
}